import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";

import {
    allWedgeplay,
    fetchWedgeplay,
    deleteWedgeplay
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/editform';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class wedgeplay extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            adddiv:false,
            editdiv:false,
            seldate:'', 
            student:'',
            eid:'', 
            carryform: [{ carry : ""}],
            cntcry:1,
            clubform: [{ club : ""}],
            cntclub:1,
            ballform: [{ ball : ""}],
            cntball:1,
            rateform: [{ rate : ""}],
            cntrate:1,
            loftform: [{ loft : ""}],
            cntloft:1,
            dynamicform: [{ dynamic : ""}],
            cntdynamic:1,
            launchform: [{ launch : ""}],
            cntlaunch:1,
            landingform: [{ landing : ""}],
            cntlanding:1,  
         };  
         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

    UNSAFE_componentWillMount() {
	   this.props.allWedgeplay();
	}


    onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true,
      });
    } 
      
    onBackSection() {
		this.setState({ 
         adddiv:false,
         viewdiv:true,
         editdiv:false,

       });
	}  


    editAssessment(gid){
        this.props.fetchWedgeplay(gid).then((data) => {   
            var resdata=data.data;
            
            var allcarry=resdata[0].gwp_carry.split(",");
            var trcryobj=[]; 
            var trcrycnt=1;
            if(allcarry.length!=0){
               {allcarry.map((teamval) => (   
                  trcryobj.push({
                     carry: teamval
                  })
               ))}
               trcrycnt=allcarry.length;
            }else{
               trcryobj.push({
                  carry: ''
               })
            }

            var allclub=resdata[0].gwp_clubspeed.split(",");
            var trclubobj=[]; 
            var trclubcnt=1;
            if(allclub.length!=0){
               {allclub.map((teamval) => (   
                  trclubobj.push({
                     club: teamval
                  })
               ))}
               trclubcnt=allclub.length;
            }else{
               trclubobj.push({
                  club: ''
               })
            }

            var allball=resdata[0].gwp_ballspeed.split(",");
            var trballobj=[]; 
            var trballcnt=1;
            if(allball.length!=0){
               {allball.map((teamval) => (   
                  trballobj.push({
                     ball: teamval
                  })
               ))}
               trballcnt=allball.length;
            }else{
               trballobj.push({
                  ball: ''
               })
            }

            var allrate=resdata[0].gwp_spinrate.split(",");
            var trrateobj=[]; 
            var trratecnt=1;
            if(allrate.length!=0){
               {allrate.map((teamval) => (   
                  trrateobj.push({
                     rate: teamval
                  })
               ))}
               trratecnt=allrate.length;
            }else{
               trrateobj.push({
                  rate: ''
               })
            }

            var allloft=resdata[0].gwp_spinloft.split(",");
            var trloftobj=[]; 
            var trloftcnt=1;
            if(allloft.length!=0){
               {allloft.map((teamval) => (   
                  trloftobj.push({
                     loft: teamval
                  })
               ))}
               trloftcnt=allloft.length;
            }else{
               trloftobj.push({
                  loft: ''
               })
            }

            var alldynm=resdata[0].gwp_dynamicloft.split(",");
            var trdynmobj=[]; 
            var trdynmcnt=1;
            if(alldynm.length!=0){
               {alldynm.map((teamval) => (   
                  trdynmobj.push({
                     dynamic: teamval
                  })
               ))}
               trdynmcnt=alldynm.length;
            }else{
               trdynmobj.push({
                  dynamic: ''
               })
            }

            var alllunh=resdata[0].gwp_launchangle.split(",");
            var trlunhobj=[]; 
            var trlunhcnt=1;
            if(alllunh.length!=0){
               {alllunh.map((teamval) => (   
                  trlunhobj.push({
                     launch: teamval
                  })
               ))}
               trlunhcnt=alllunh.length;
            }else{
               trlunhobj.push({
                  launch: ''
               })
            }

            var allland=resdata[0].gwp_landingangle.split(",");
            var trlandobj=[]; 
            var trlandcnt=1;
            if(allland.length!=0){
               {allland.map((teamval) => (   
                  trlandobj.push({
                     landing: teamval
                  })
               ))}
               trlandcnt=allland.length;
            }else{
               trlandobj.push({
                  landing: ''
               })
            }
            

            this.setState({ 
                seldate:resdata[0].gwp_date,  
                student:resdata[0].gwp_userID, 
                eid:resdata[0].gwpID, 
                carryform: trcryobj,
                cntcry:trcrycnt, 
                clubform: trclubobj,
                cntclub:trclubcnt,  
                ballform: trballobj,
                cntball:trballcnt,  
                rateform:trrateobj,
                cntrate:trratecnt,
                loftform:trloftobj,
                cntloft:trloftcnt,
                dynamicform:trdynmobj,
                cntdynamic:trdynmcnt,
                launchform:trlunhobj,
                cntlaunch:trlunhcnt,
                landingform:trlandobj,
                cntlanding:trlandcnt,
            });

            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                editdiv:true,
       
            });

        });
    }

    deleteForm(data){
      this.data = data;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteWedgeplay(this.data);
            this.data = ""
        }
    }

    render() {
       const { match, tqwedgeplaylist, loading } = this.props;
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "ACTION" },
            { name: "action1", label: "ACTION1" },
          
        ];
        const tabledata=tqwedgeplaylist.map((assmntval,idx) => {     
                     const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.gwpID)}><EditOutlinedIcon/></IconButton>;
                     const dbtn=<IconButton className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.gwpID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                name: assmntval.student,
                cdate: assmntval.cdate,
                action: ebtn,
                action1:dbtn,
                
                }
        }); 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Technique Wedge Play | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.tqwedgeplay" />} match={match} />
             
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-md-12">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Wedge Play</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                 <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                 <UpdateItems onClick={this.onBackSection} data={this.state}/>   
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'wedge play'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ tqwedgeplay }) => {
	const { tqwedgeplaylist, loading } = tqwedgeplay;
	return { tqwedgeplaylist, loading };
}

export default connect(mapStateToProps, {
    allWedgeplay,
    fetchWedgeplay,
    deleteWedgeplay
})(wedgeplay); 